import {useRouter} from 'next/router';

import {useConsumerSubscriptionPlan} from '@udemy/subscription-graphql';

import {useHasCouponInUrl} from 'src/hooks/useCouponCodeParam';

/**
 * `true` when consumer subscription plan pricing is safe to render (no coupon price flash).
 * With a coupon in the URL, waits for Next router hydration so we do not briefly show undiscounted
 * list price from an initial fetch that omitted the coupon.
 */
export function usePersonalPlanSubscriptionPricingReady(): boolean {
    const router = useRouter();
    const plan = useConsumerSubscriptionPlan();
    const hasCouponInUrl = useHasCouponInUrl();

    if (plan?.isLoading) {
        return false;
    }

    if (hasCouponInUrl && !router?.isReady) {
        return false;
    }

    return true;
}
